import React from 'react';
import { FaCloud, FaList, FaSeedling } from "../../../icons";
import { toAbsoluteUrl } from '../../../../../../_metronic/helpers';
import { NotImported } from '../../../NotInformat';
import { getDayOfWeek } from '../../../../../utils/date';

type Props = {
    data: any;
    clima: any
}

export function DetailsPlants({data, clima}: Props) {
  return (
    <div className='d-flex flex-column flex-grow-1' style={{height: '35rem', overflow: 'auto'}}>
        <div className='d-flex flex-wrap' style={{gap: '0.7rem'}}>
            <div 
                className='card border border-gray-300 border-dashed rounded py-3 px-4 mb-3 d-flex flex-wrap'
                style={{flexDirection: 'column', width: '100%'}}  
            >
            <div style={{display: 'flex', alignItems: 'center', gap: '0.7rem', marginBottom: '1.5rem'}}>
                {/* <i className='bi bi-three-dots fs-3'></i> */}
                <div style={{width: '2.5rem', height: '2.5rem', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}} className='bg-primary'>
                <FaList className='text-light' style={{fontSize: '1.5rem'}}/>
                </div>
                
                <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bold fs-5 mb-1'>Detalhes da usina</span>
                {/* <span className='text-muted mt-1 fw-semibold fs-5'>( {unitBranch.name} )</span> */}
                </h3>
            </div>
            
            <div style={{display: 'flex', flexDirection: 'column'}}>
                
                <div className='d-flex divItemInformationsDuo'>
                <div className='fw-bold fs-6 text-gray-400'>Capacidade: </div>
                <div className='fs-6 fw-bolder'>
                {data && data.capacity ? data.capacity + " KWp" : 0 + ' KWp'}
                </div>
                </div>

                <div className='separator separator-solid my-2'></div>

                <div className='d-flex divItemInformationsDuo'>
                <div className='fw-bold fs-6 text-gray-400'>Tensão: </div>
                <div className='fs-6 fw-bolder'>
                    {data && data.tensao_v2 ? data.tensao_v2 + " Volts" : 0 + ' Volts'}
                </div>
                </div>

                <div className='separator separator-solid my-2'></div>

                <div className='d-flex divItemInformationsDuo'>
                <div className='fw-bold fs-6 text-gray-400'>Tipo de conexão: </div>
                <div className='fs-6 fw-bolder'>
                    {data && data.type_conection_v2 ? 
                        data.type_conection_v2 === "monofasico" ? "Monofásico"
                        : data.type_conection_v2 === "bifasico" ? "Bifásico"
                        : data.type_conection_v2 === "trifasico" ? "Trifásico"
                        : <NotImported className="fs-6 fw-bolder"/>
                    : <NotImported className="fs-6 fw-bolder"/>}
                </div>
                </div>

                <div className='separator separator-solid my-2'></div>

                <div className='d-flex divItemInformationsDuo'>
                <div className='fw-bold fs-6 text-gray-400'>Total Investido: </div>
                <div className='fs-6 fw-bolder'>
                    R$ {data && data.value_implementation ? data.value_implementation : 0}
                </div>
                </div>

                <div className='separator separator-solid my-2'></div>

                <div className='d-flex divItemInformationsDuo'>
                <div className='fw-bold fs-6 text-gray-400'>Unidade ( Filial ): </div>
                <div className='fs-6 fw-bolder'>
                    {data && data.unitBranch ? data.unitBranch.companyName : <NotImported className="fs-5 fw-bolder"/>}
                </div>
                </div>
            </div>

            </div>

            {data && data.plano && (data.plano === "PREMIUM" || data.plano === "STARTER") &&
            (<div 
            className='card border border-gray-300 border-dashed rounded py-4 px-5 pt-4 mb-3'
            style={{width: '100%', display: 'flex', flexDirection: 'column'}}
            >
            <div style={{display: 'flex', alignItems: 'center', gap: '0.7rem', marginBottom: '1.5rem'}}>
                <div style={{width: '2.5rem', height: '2.5rem', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}} className='bg-primary'>
                <FaCloud className='text-light' style={{fontSize: '1.5rem'}}/>
                </div>
                
                <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bold fs-5 mb-1'>Previsão do tempo</span>
                </h3>
            </div>
            
            <div className='d-flex divAddInformations'>
                {clima && clima.length > 0 ?
                clima.map((dayClima) => {
                    return (
                    <div className='d-flex divItemMenu'>
                        <img src={toAbsoluteUrl(`https://openweathermap.org/img/wn/${dayClima.weather && dayClima.weather[0].icon ? dayClima.weather[0].icon : ""}@2x.png`)} className="imgItemMenu" alt='Metornic' />
                        <div className='fw-bold fs-7 text-gray-400'>{dayClima.temp && dayClima.temp.min ? dayClima.temp.min.toFixed(0) : 0}°C | {dayClima.temp && dayClima.temp.day ? dayClima.temp.day.toFixed(0) : 0}°C | {dayClima.temp && dayClima.temp.max ? dayClima.temp.max.toFixed(0) : 0}°C </div>
                        <div className='fs-7 fw-bolder'>{dayClima && dayClima.dt ? getDayOfWeek(dayClima.dt) : ""}</div>
                    </div>
                    )
                })
                : <>Dados climáticos não encontrados</>}
            </div>

            </div>)}

            <div 
            className='card border border-gray-300 border-dashed rounded py-4 px-5 pt-4 mb-3'
            style={{width: '100%', display: 'flex', flexDirection: 'column'}}
            >
            <div style={{display: 'flex', alignItems: 'center', gap: '0.7rem', marginBottom: '1.5rem'}}>
                {/* <i className='bi bi-three-dots fs-3'></i> */}
                <div style={{width: '2.5rem', height: '2.5rem', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}} className='bg-primary'>
                    <FaSeedling className='text-light' style={{fontSize: '1.5rem'}}/>
                </div>
                
                <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bold fs-5 mb-1'>Benefícios Ambientais</span>
                {/* <span className='text-muted mt-1 fw-semibold fs-5'>( {unitBranch.name} )</span> */}
                </h3>
            </div>
            
            <div className='d-flex divAddInformations'>
                <div className='d-flex divItemMenu'>
                <img src={toAbsoluteUrl('/media/imgs/co2.png')} className="imgItemMenu" alt='Metornic' />
                <div className='fw-bold fs-7 text-gray-400'>Co2 evitada: </div>
                <div className='fs-7 fw-bolder'>{data && data.co2 ? data.co2 + " ton" : 0 + ' ton'}</div>
                </div>

                <div className='d-flex divItemMenu'>
                <img src={toAbsoluteUrl('/media/imgs/so2.png')} className="imgItemMenu" alt='Metornic' />
                <div className='fw-bold fs-7 text-gray-400'>So2 evitada: </div>
                <div className='fs-7 fw-bolder'>{data && data.so2 ? data.so2 + " ton" : 0 + ' ton'}</div>
                </div>

                <div className='d-flex divItemMenu'>
                <img src={toAbsoluteUrl('/media/imgs/coal.png')} className="imgItemMenu" alt='Metornic' />
                <div className='fw-bold fs-7 text-gray-400'>Coal evitado: </div>
                <div className='fs-7 fw-bolder'>{data && data.coal ? data.coal + " ton" : 0 + ' ton'}</div>
                </div>
            </div>

            </div>
            
        </div>
    </div>
  );
}